<template>
    <div id="app" v-bind:class="$route.name" class="container-fluid">
        <navbar :authenticated="isAuthenticated"></navbar>
        <div class="row">
            <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-lg-8 col-lg-offset-2">
                <router-view></router-view>
                <div v-if="apiService.errorsOccurred" class="notification-bar alert alert-danger" role="alert">
                    <div v-for="error in apiService.errorList">{{error}}</div>
                </div>
            </div>
        </div>
        <div v-if="apiService.isWaiting" class="load-spinner">
            <i class="fa fa-spinner fa-pulse fa-3x"></i>
            <span class="sr-only">Loading...</span>
        </div>
        <footer>
          <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-lg-8 col-lg-offset-2">
            <div>&copy;{{year}} Lewis Rice</div>
            <nav>
                <router-link to="/terms">Terms &amp; Conditions</router-link> &bull;
                <router-link to="/privacy">Privacy Policy</router-link>
            </nav>
            <div class="disclaimer">
                <small>
                    <p>
                        The Lewis Rice LLC Estate Planning Portal (the “Portal”) and the materials/documents provided through the Portal may only be used by the individuals given the right to access such Portal and materials/documents by Lewis Rice LLC (the “Firm”) for the purposes for which the Firm has indicated such access and materials/documents are being provided.  The Portal and materials/documents may not be used by any other persons or for any other purposes without express consent of the Firm.
                    </p>
                    <p>
                        The Portal is being, and has been, provided “as is, where is” without representation or warranty.  For avoidance of doubt, the Firm makes no representation or warranty of any kind, with regard to the operation of the Portal or, that the Portal will operate without interruption or be secure, free of harmful code, or error-free. All third-party materials, whether offered as part of the Portal or separately, are provided "as is, where is" and any representation or warranty of or concerning any third-party materials is strictly between client and the third-party owner or licensor of such third-party materials.
                    </p>
              </small>
            </div>
          </div>
        </footer>
 </div>
</template>

<script>
    import APIService from '@/services/api.service';
    import Navbar from '@/components/Navbar'
    import NavbarAlt from '@/components/NavbarAlt'
    import { Store } from '@/store'
    import UserService from '@/services/user.service'

    export default {
        name: 'app',
        data: function() {
            return {
                store: Store,
                apiService: APIService,
                year: new Date().getFullYear()
            }
        },
        components: {
            //'navbar': Navbar
            'navbar': NavbarAlt
        },
        computed: {
            isAuthenticated: function() { return this.store.data.user.id }
        }
    }
</script>

<style lang="scss">
    @import '../node_modules/font-awesome/css/font-awesome.css';
    @import 'main.scss';
</style>



// WEBPACK FOOTER //
// App.vue?dffc8adc